
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import {
  NavBar,
  BaseModal,
  BankAccount,
  Heading,
  Row,
  StatusBar,
  HelperView,
  ButtonPrimary,
  LoaderIndicator
} from '@warrenbrasil/nebraska-web';
import { CloseButton } from '@/modules/common/components/buttons';
import {
  addBodyScroll,
  toggleBodyScroll
} from '@/modules/common/helpers/browser';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import {
  TransferDetailsRow,
  WithdrawalAccountResponse
} from '@/modules/transaction/services/withdraws/withdraws-bff-types';
import { WithdrawsBFF } from '@/modules/transaction/services/withdraws';
import CancelWithdrawModal from '@/modules/transaction/components/TransactionModal/components/CancelWithdrawModal/CancelWithdrawModal.vue';
import {
  trackWithdrawModalLoad,
  trackCancelWithdrawClick
} from '../../track-events';

@Component({
  components: {
    BaseModal,
    CloseButton,
    NavBar,
    BankAccount,
    Heading,
    Row,
    StatusBar,
    LoaderIndicator,
    CancelWithdrawModal,
    HelperView,
    ButtonPrimary
  }
})
export default class WithdrawModal extends Vue {
  @Prop({ type: String, required: true })
  private id!: string;

  @Prop({ type: Boolean, default: false })
  private isOpen!: boolean;

  readonly NebraskaColors = NebraskaColors;

  withdraw: WithdrawalAccountResponse = {};
  bff = new WithdrawsBFF();
  isLoading = false;
  isOpenCancelModal = false;
  hasError = false;

  created() {
    toggleBodyScroll();
    trackWithdrawModalLoad();
  }

  get transferDetailRows(): TransferDetailsRow[] {
    return this.withdraw.transferDetails?.rows || [];
  }

  get statusBarStages() {
    return this.withdraw.statusBarStages;
  }

  get transferDetails() {
    return this.withdraw.transferDetails;
  }

  get destinationAccount() {
    return this.withdraw.destinationAccount;
  }

  get cancelModal() {
    return this.withdraw.cancelModal;
  }

  get computedModalSize() {
    return !this.hasError ? 'md' : 'sm';
  }

  get shouldShowDestinationAccount() {
    return this.destinationAccount?.title !== '';
  }

  @Emit('close')
  closeModal() {}

  async beforeMount() {
    await this.loadReceipt();
  }

  @Watch('id')
  private async loadReceipt() {
    this.isLoading = true;
    this.hasError = false;
    try {
      if (this.id) {
        const data = await this.bff.getWithdrawAccount(this.id);
        this.withdraw = { ...data.withdrawalReceipt };
      }
    } catch (e) {
      this.hasError = true;
    } finally {
      this.isLoading = false;
    }
  }

  openCancelModal() {
    this.isOpenCancelModal = true;
    trackCancelWithdrawClick();
  }

  closeCancelModal() {
    this.isOpenCancelModal = false;
  }

  beforeDestroy() {
    addBodyScroll();
    this.hasError = false;
  }
}
